import * as z from 'zod';

export const registrarQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type RegistrarQueryLinkerSchema = z.infer<typeof registrarQueryLinkerSchema>;
